import { Routes, Route } from "react-router-dom";
import { AdminAuthProvider } from "./contexts/AdminAuthContext";
import AdminLayout from "./components/AdminLayout";
import AdminErrorBoundary from "./components/AdminErrorBoundary";
import AdminLogin from "./pages/AdminLogin";
import AdminHome from "./pages/AdminHome";
import AdminTable from "./pages/AdminTable";
import AdminRecord from "./pages/AdminRecord";
import AdminAudit from "./pages/AdminAudit";
import AdminOrdersByState from "./pages/AdminOrdersByState";
import AdminChangeParent from "./pages/AdminChangeParent";
import AdminCopyProduct from "./pages/AdminCopyProduct";
import AdminReport from "./pages/AdminReport";
import AdminMediaSummaries from "./pages/AdminMediaSummaries";
import AdminCommissionPayouts from "./pages/AdminCommissionPayouts";
import AdminManualCommissionAdjustment from "./pages/AdminManualCommissionAdjustment";
import AdminNotifications from "./pages/AdminNotifications";
import AdminPrecarios from "./pages/AdminPrecarios";
import AdminConsultantRenewals from "./pages/AdminConsultantRenewals";
import AdminInscricoesPendentes from "./pages/AdminInscricoesPendentes";
import AdminConfirmClients from "./pages/AdminConfirmClients";
import AdminImportClients from "./pages/AdminImportClients";
import AdminMarketing from "./pages/AdminMarketing";
import AdminAttribution from "./pages/AdminAttribution";
import AdminCheckoutFunnel from "./pages/AdminCheckoutFunnel";
import AdminIncentivos from "./pages/AdminIncentivos";
import AdminVales from "./pages/AdminVales";
import AdminMoosendMaps from "./pages/AdminMoosendMaps";
import AdminBlackMonth from "./pages/AdminBlackMonth";
import AdminAI from "./pages/AdminAI";
import AdminCursoInscricoes from "./pages/AdminCursoInscricoes";
import AdminCursoNotas from "./pages/AdminCursoNotas";
import AdminCursoDTP from "./pages/AdminCursoDTP";
import AdminCursoPresencas from "./pages/AdminCursoPresencas";
import AdminCursoFormadores from "./pages/AdminCursoFormadores";
import AdminCursoContratos from "./pages/AdminCursoContratos";
import AdminFormadores from "./pages/AdminFormadores";
import AdminPacks from "./pages/AdminPacks";
import AdminCursoSessoes from "./pages/AdminCursoSessoes";
import AdminCursoEdit from "./pages/AdminCursoEdit";
import AdminCursosSituacao from "./pages/AdminCursosSituacao";
import AdminCopiarCurso from "./pages/AdminCopiarCurso";
import AdminCursoCertificacao from "./pages/AdminCursoCertificacao";
import AdminTiposCertificacao from "./pages/AdminTiposCertificacao";
import AdminCrmBotoes from "./pages/AdminCrmBotoes";
import AdminImportCursos from "./pages/AdminImportCursos";
import AdminCursoCheckin from "./pages/AdminCursoCheckin";
import AdminCursoCheckinLogin from "./pages/AdminCursoCheckinLogin";
import AdminDreams from "./pages/AdminDreams";
import AdminCoachVirtual from "./pages/AdminCoachVirtual";
import AdminDownloads from "./pages/AdminDownloads";
import AdminJobs from "./pages/AdminJobs";
import AdminLeadIntelligence from "./pages/AdminLeadIntelligence";

export default function AdminApp() {
  return (
    <AdminAuthProvider>
      <AdminErrorBoundary>
        <Routes>
          <Route path="login" element={<AdminLogin />} />
          <Route path="cursos/checkin" element={<AdminCursoCheckin />} />
          <Route path="cursos/checkin/login" element={<AdminCursoCheckinLogin />} />
          <Route element={<AdminLayout />}>
            <Route index element={<AdminHome />} />
            <Route path="audit" element={<AdminAudit />} />
            <Route path="notifications" element={<AdminNotifications />} />
            <Route path="dashboard/orders" element={<AdminOrdersByState />} />
            <Route path="operations/change-parent" element={<AdminChangeParent />} />
            <Route path="operations/copy-product" element={<AdminCopyProduct />} />
            <Route path="operations/commission-payouts" element={<AdminCommissionPayouts />} />
            <Route path="operations/manual-commission-adjustment" element={<AdminManualCommissionAdjustment />} />
            <Route path="operations/confirm-clients" element={<AdminConfirmClients />} />
            <Route path="operations/import-clients" element={<AdminImportClients />} />
            <Route path="marketing" element={<AdminMarketing />} />
            <Route path="attribution" element={<AdminAttribution />} />
            <Route path="checkout-funnel" element={<AdminCheckoutFunnel />} />
            <Route path="incentivos" element={<AdminIncentivos />} />
            <Route path="vales" element={<AdminVales />} />
            <Route path="moosend-maps" element={<AdminMoosendMaps />} />
            <Route path="black-month" element={<AdminBlackMonth />} />
            <Route path="ai" element={<AdminAI />} />
            <Route path="cursos/inscricoes" element={<AdminCursoInscricoes />} />
            <Route path="cursos/notas" element={<AdminCursoNotas />} />
            <Route path="cursos/dtp" element={<AdminCursoDTP />} />
            <Route path="cursos/presencas" element={<AdminCursoPresencas />} />
            <Route path="cursos/formadores" element={<AdminCursoFormadores />} />
            <Route path="cursos/contratos" element={<AdminCursoContratos />} />
            <Route path="formadores" element={<AdminFormadores />} />
            <Route path="packs" element={<AdminPacks />} />
            <Route path="inscricoes-pendentes" element={<AdminInscricoesPendentes />} />
            <Route path="cursos/sessoes" element={<AdminCursoSessoes />} />
            <Route path="cursos/edit" element={<AdminCursoEdit />} />
            <Route path="cursos/situacao" element={<AdminCursosSituacao />} />
            <Route path="cursos/copiar" element={<AdminCopiarCurso />} />
            <Route path="cursos/certificacao" element={<AdminCursoCertificacao />} />
            <Route path="tipos-certificacao" element={<AdminTiposCertificacao />} />
            <Route path="crm-botoes" element={<AdminCrmBotoes />} />
            <Route path="cursos/import-base" element={<AdminImportCursos />} />
            <Route path="precarios" element={<AdminPrecarios />} />
            <Route path="dashboard/consultant-renewals" element={<AdminConsultantRenewals />} />
            <Route path="reports/clients-by-product" element={<AdminReport reportKey="clients-by-product" />} />
            <Route path="reports/clients-by-pack" element={<AdminReport reportKey="clients-by-pack" />} />
            <Route path="reports/commissions-client" element={<AdminReport reportKey="commissions-client" />} />
            <Route path="reports/consultant-levels" element={<AdminReport reportKey="consultant-levels" />} />
            <Route path="reports/new-consultant-levels" element={<AdminReport reportKey="new-consultant-levels" />} />
            <Route path="reports/new-pins" element={<AdminReport reportKey="new-pins" />} />
            <Route path="reports/clients-volume" element={<AdminReport reportKey="clients-volume" />} />
            <Route path="reports/active-subscriptions" element={<AdminReport reportKey="active-subscriptions" />} />
            <Route path="media-summaries" element={<AdminMediaSummaries />} />
            <Route path="dreams" element={<AdminDreams />} />
            <Route path="coach-virtual" element={<AdminCoachVirtual />} />
            <Route path="downloads" element={<AdminDownloads />} />
            <Route path="jobs" element={<AdminJobs />} />
            <Route path="lead-intelligence" element={<AdminLeadIntelligence />} />
            <Route path="t/:schema/:name" element={<AdminTable />} />
            <Route path="t/:schema/:name/view/:pk" element={<AdminRecord viewOnly />} />
            <Route path="t/:schema/:name/:pk" element={<AdminRecord />} />
          </Route>
        </Routes>
      </AdminErrorBoundary>
    </AdminAuthProvider>
  );
}
